import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { spacingV2 } from '~/src/dash/components/layout/common';
import { Col, Cols, Panel, Panels, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  EReportDelivery,
  EReportFrequency,
  EReportPeriod,
} from '~/src/dash/views/reporting/common';
import { CustomizeDataSection } from '~/src/dash/views/reporting/ReportBuilder/CustomizeData/index';
import { DimensionsSection } from '~/src/dash/views/reporting/ReportBuilder/Dimensions/index';
import { FiltersSection } from '~/src/dash/views/reporting/ReportBuilder/Filters/index';
import { MetricsSection } from '~/src/dash/views/reporting/ReportBuilder/Metrics/index';
import { OverviewSection } from '~/src/dash/views/reporting/ReportBuilder/Overview/index';
import { QuerySection } from '~/src/dash/views/reporting/ReportBuilder/Query/index';
import {
  IScheduleConfig,
  ScheduleSection,
} from '~/src/dash/views/reporting/ReportBuilder/Schedule/index';
import { TopBar } from '~/src/dash/views/topbar/TopBar';
// import { getS3AccessPoint, IS3AccessPoint } from '~/src/dash/api/s3-access-points';
// import { IHttpResponse } from '~/src/dash/api/rest';
// import { EBool } from '~/src/dash/api/types/bool';

// interface IError {
//   s3AccessPoint: string;
// }

export const ReportBuilderNew = () => {
  // const defaultError : IError = {
  //   s3AccessPoint: '',
  // }
  const today = moment(new Date());
  const defaultScheduleConfig: IScheduleConfig = {
    dateRange: [today, today],
    delivery: String(EReportDelivery.Email),
    frequency: String(EReportFrequency.FrequencyDaily),
    isStatusActive: false,
    period: String(EReportPeriod.LastDay),
    recipients: [],
  };
  const [scheduleConfig, setScheduleConfig] = useState<IScheduleConfig>(defaultScheduleConfig);
  // const [s3AccessPoint, setS3AccessPoint] = useState<IS3AccessPoint | null>(null)
  // const [error, setError] = useState<IError>(defaultError);

  // this is used to get the S3 detail for schedulign setting
  // need to comment it out now cause I'ma not sure how Nathan's work for this component is so far
  // TODO: uncomment and inetegrate this to Nathan's PR
  // const fetchS3AccessPoint = () => {
  //   const isTTDReport =  EBool.fromBool(reportType.ID === 21)
  //   getS3AccessPoint(publisherID, isTTDReport).then((val: IHttpResponse<IS3AccessPoint>) => {
  //     setS3AccessPoint(val.parsedBody as IS3AccessPoint);
  //   }).catch((err) => {
  //     setError({ ...error, s3AccessPoint: err })
  //   });
  // }

  // refetch the S3 detail when publisher or reportType changes
  // useEffect(() => {
  //   fetchS3AccessPoint();
  // }, [publisherID, reportType])

  // this useEffect should be updated to update the schedule setting whenever
  // we open a new report or load in a different existing report
  useEffect(() => {
    setScheduleConfig(defaultScheduleConfig);
  }, []);

  return (
    <Panels vertical relative minWidthMain>
      <Panel largeHorizontalPadding smallVerticalPadding>
        <TopBar title='Reporting Beta' />
      </Panel>

      <Panel largeHorizontalPadding noVerticalPadding>
        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
          <Col>
            <Text extraLarge bold>
              New Report
            </Text>
          </Col>
        </Cols>
      </Panel>

      <Panel
        largeHorizontalPadding
        verticalPadding
        marginBottom={spacingV2.large}
        style={{ overflowX: 'auto' }} // this ensures the Panel's height expands with the content
      >
        <Panels vertical relative minWidthMain>
          <Panel highlighted marginBottom={spacingV2.large}>
            <Rows>
              <Row
                style={{
                  borderBottom: `1px solid ${publicaColors.lightGray}`,
                }}
              >
                <OverviewSection />
              </Row>
              <Row
                style={{
                  borderBottom: `1px solid ${publicaColors.lightGray}`,
                }}
              >
                <QuerySection />
              </Row>
              <Row
                style={{
                  borderBottom: `1px solid ${publicaColors.lightGray}`,
                }}
              >
                <DimensionsSection />
              </Row>
              <Row
                style={{
                  borderBottom: `1px solid ${publicaColors.lightGray}`,
                }}
              >
                <FiltersSection />
              </Row>
              <Row
                style={{
                  borderBottom: `1px solid ${publicaColors.lightGray}`,
                }}
              >
                <MetricsSection />
              </Row>
              <Row>
                <CustomizeDataSection />
              </Row>
            </Rows>
          </Panel>

          <Panel basePadding highlighted>
            <ScheduleSection
              isReportActive={scheduleConfig.isStatusActive}
              reportFrequency={scheduleConfig.frequency}
              reportPeriod={scheduleConfig.period}
              reportDateRange={scheduleConfig.dateRange}
              reportDelivery={scheduleConfig.delivery}
              reportRecipients={scheduleConfig.recipients}
              s3AccessPoint={null}
              // s3AccessPoint={s3AccessPoint}
              onChange={(config: IScheduleConfig) => setScheduleConfig(config)}
            />
          </Panel>
        </Panels>
      </Panel>
    </Panels>
  );
};
